import type { IconComponent, IconProps } from 'mx-icons';
import { WP_ICON_NAV } from '@wapharma/design-system';

/**
 * mx-icons Twotone defaults for admin chrome (Hamssah parity).
 * Package hardcodes color `#292D32` — override with currentColor so tokens win.
 * Secondary paths use opacity 0.4 on stroke; NavCluster firms that on hover.
 */
export const MX_NAV_ICON = {
  size: WP_ICON_NAV.size,
  color: 'currentColor',
} as const satisfies Pick<IconProps, 'size' | 'color'>;

export function navTwotoneIcon(IconCmp: IconComponent, props?: IconProps) {
  return <IconCmp {...MX_NAV_ICON} {...props} aria-hidden />;
}

export function navTwotoneItemIcon(IconCmp: IconComponent, props?: IconProps) {
  return navTwotoneIcon(IconCmp, props);
}
